import { actions } from 'Data/ReduxViewModels/NuclearGaugeStandardisation';
import { useDispatch, useSelector } from 'react-redux';
import { InjectedPropsProvider, withInjectedProps } from '../../../../../Core/InjectedPropsContext';
import { getStandardisationQueryProviderProps } from './providerProps';

let StandardisationQueryInjectedPropsProvider = ({ children }) => {
  const dispatch = useDispatch();
  const data = useSelector((s) => s.gaugeStandardisation.query);
  const setValue = (opts) => dispatch(actions.setQueryValue(opts));
  const providerData = {
    data,
    setValue,
  };
  return (
    <InjectedPropsProvider
      getProviderProps={(consumerProps, modifiers) =>
        getStandardisationQueryProviderProps(consumerProps, providerData, modifiers)
      }
    >
      {children}
    </InjectedPropsProvider>
  );
};

StandardisationQueryInjectedPropsProvider = withInjectedProps(StandardisationQueryInjectedPropsProvider);

export { StandardisationQueryInjectedPropsProvider };
export default StandardisationQueryInjectedPropsProvider;
